/**
 * Deprecated Analysis Factors
 *
 * Factors disabled based on production data analysis. The list comes from the factor registry
 * (`deprecatedReason`), so it cannot drift from it. The server forces these to false regardless of
 * client config; admin users still see the toggles, greyed out with the reason.
 */

import { FACTOR_REGISTRY } from './factorRegistry';

export interface DeprecatedFactor {
  section: string;
  key: string;
  label: string;
  reason: string;
}

export const DEPRECATED_FACTORS: Record<string, DeprecatedFactor> = Object.fromEntries(
  FACTOR_REGISTRY.flatMap((f) =>
    f.deprecatedReason
      ? [[f.id, { section: f.section, key: f.key, label: f.label, reason: f.deprecatedReason }]]
      : [],
  ),
);

export const DEPRECATED_FACTOR_PATHS = new Set(Object.keys(DEPRECATED_FACTORS));

export function isFactorDeprecated(dotPath: string): boolean {
  return DEPRECATED_FACTOR_PATHS.has(dotPath);
}
